import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CTASection() {
  const sectionReveal = useScrollReveal(0.1);

  return (
    <section ref={sectionReveal.ref} className={`py-20 md:py-28 px-4 md:px-6 bg-background-50 ${sectionReveal.isVisible ? 'scroll-reveal visible' : 'scroll-reveal'}`}>
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-6xl font-bold text-foreground-900 mb-5">
          Ready to Shop <span className="italic text-primary-600">Smarter?</span>
        </h2>
        <p className="text-foreground-600 text-base md:text-lg mb-10 max-w-xl mx-auto">
          Access the complete Superbuy sheet with 10,000+ curated finds organized across 14 categories.
          Start your smarter shopping journey today.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300"
          >
            Buy It Now
            <i className="ri-arrow-right-line"></i>
          </a>
          <Link
            to="/article/what-is-superbuy-spreadsheet"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-foreground-300 text-foreground-700 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-50 transition-all duration-300"
          >
            Learn More First
          </Link>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { src: 'https://readdy.ai/api/search-image?query=Single%20vibrant%20red%20and%20white%20athletic%20running%20shoe%20floating%20against%20soft%20gradient%20background%2C%20dynamic%20angle%20showing%20sole%20detail%2C%20clean%20studio%20lighting%20with%20crisp%20shadows%2C%20modern%20product%20photography%2C%20bold%20color%20contrast&width=200&height=200&seq=cta-product-shoe&orientation=squarish', alt: 'Shoes' },
            { src: 'https://readdy.ai/api/search-image?query=Elegant%20crossbody%20bag%20in%20burnt%20sienna%20leather%20with%20gold%20chain%20strap%20against%20soft%20neutral%20gradient%20background%2C%20clean%20studio%20photography%2C%20luxury%20accessories%20product%20shot%2C%20warm%20earth%20tones%2C%20minimalist%20styling&width=200&height=200&seq=cta-product-bag&orientation=squarish', alt: 'Bags' },
            { src: 'https://readdy.ai/api/search-image?query=Modern%20dad%20hat%20in%20sage%20green%20corduroy%20with%20small%20embroidered%20logo%20against%20soft%20pastel%20gradient%2C%20clean%20product%20photography%2C%20trendy%20streetwear%20aesthetic%2C%20warm%20natural%20tones%2C%20floating%20composition&width=200&height=200&seq=cta-product-cap&orientation=squarish', alt: 'Headwear' },
            { src: 'https://readdy.ai/api/search-image?query=Chunky%20knit%20hoodie%20in%20oatmeal%20cream%20color%20draped%20softly%20against%20gentle%20gradient%20background%2C%20cozy%20texture%20detail%20visible%2C%20warm%20studio%20lighting%2C%20lifestyle%20product%20photography%2C%20hygge%20aesthetic&width=200&height=200&seq=cta-product-hoodie&orientation=squarish', alt: 'Hoodies' },
            { src: 'https://readdy.ai/api/search-image?query=Sleek%20black%20windbreaker%20jacket%20with%20reflective%20zipper%20detail%20against%20cool%20gradient%20background%2C%20modern%20streetwear%20product%20photography%2C%20clean%20studio%20lighting%2C%20urban%20athletic%20aesthetic%2C%20minimalist%20composition&width=200&height=200&seq=cta-product-jacket&orientation=squarish', alt: 'Jackets' },
          ].map((item) => (
            <div key={item.alt} className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden shadow-sm">
              <img
                src={item.src}
                alt={item.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}